import { useQuery } from "react-query";
import { PostCodeItem } from "../../types/postCodes";
import useApi, { ApiError } from "../useApi";

function usePostCodes(zipCode: string) {
  const { fetchPostCodes } = useApi();
  return useQuery<PostCodeItem[], ApiError>(
    ["post-codes", zipCode],
    async () => fetchPostCodes(zipCode),
    {
      enabled: zipCode.length > 1,
      refetchOnWindowFocus: false,
      retry: 2,
    }
  );
}

export default usePostCodes;
